export interface HashProgress {
  completedBytes: number;
  totalBytes: number;
}

type HashWorkerMessage =
  | { type: 'progress'; completedBytes: number; totalBytes: number }
  | { type: 'complete'; digest: string }
  | { type: 'error'; code: string };

export function hashFileBlake3(
  file: File,
  onProgress: (progress: HashProgress) => void,
  signal?: AbortSignal,
): Promise<string> {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(new DOMException('Hashing aborted', 'AbortError'));
      return;
    }
    const worker = new Worker(new URL('./blake3.worker.ts', import.meta.url), { type: 'module' });
    const stop = () => worker.terminate();
    const abort = () => {
      stop();
      reject(new DOMException('Hashing aborted', 'AbortError'));
    };
    signal?.addEventListener('abort', abort, { once: true });

    worker.onerror = () => {
      signal?.removeEventListener('abort', abort);
      stop();
      reject(new Error('hash_worker_failed'));
    };
    worker.onmessage = ({ data }: MessageEvent<HashWorkerMessage>) => {
      if (data.type === 'progress') {
        onProgress(data);
        return;
      }
      signal?.removeEventListener('abort', abort);
      stop();
      if (data.type === 'complete') resolve(data.digest);
      else reject(new Error(data.code));
    };
    worker.postMessage({ file, chunkBytes: 8 * 1024 * 1024 });
  });
}
